import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "fieldsData"];

  connect() {
    try {
      this.fields = JSON.parse(this.fieldsDataTarget.value || "[]");
    } catch {
      this.fields = [];
    }
    this.render();
  }

  addSignature() {
    this.fields.push({ type: "signature", signer_index: 0 });
    this.sync();
  }

  addDate() {
    this.fields.push({ type: "date", signer_index: 0 });
    this.sync();
  }

  remove(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10);
    this.fields.splice(index, 1);
    this.sync();
  }

  sync() {
    this.fieldsDataTarget.value = JSON.stringify(this.fields);
    this.render();
  }

  render() {
    this.listTarget.innerHTML = "";

    if (this.fields.length === 0) {
      const empty = document.createElement("li");
      empty.className = "list-group-item text-muted small fst-italic";
      empty.textContent = "No signature fields added yet.";
      this.listTarget.appendChild(empty);
      return;
    }

    this.fields.forEach((field, index) => {
      const li = document.createElement("li");
      li.className =
        "list-group-item d-flex align-items-center justify-content-between py-2";

      const label = document.createElement("div");
      label.className = "d-flex align-items-center gap-2";

      const icon = document.createElement("i");
      icon.className =
        field.type === "date"
          ? "bi bi-calendar-date text-primary"
          : "bi bi-pen text-danger";
      label.appendChild(icon);

      const text = document.createElement("span");
      text.className = "small";
      text.textContent = `Signer ${field.signer_index + 1} — ${
        field.type === "date" ? "Date" : "Signature"
      } Field`;
      label.appendChild(text);

      const select = document.createElement("select");
      select.className = "form-select form-select-sm ms-2";
      select.style.width = "auto";
      for (let i = 0; i < 5; i++) {
        const opt = document.createElement("option");
        opt.value = i;
        opt.textContent = `Signer ${i + 1}`;
        if (i === field.signer_index) opt.selected = true;
        select.appendChild(opt);
      }
      select.addEventListener("change", (e) => {
        this.fields[index].signer_index = parseInt(e.target.value, 10);
        this.fieldsDataTarget.value = JSON.stringify(this.fields);
      });
      label.appendChild(select);

      const removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "btn btn-outline-danger btn-sm";
      removeBtn.dataset.index = index;
      removeBtn.dataset.action = "content-signature-fields#remove";
      removeBtn.innerHTML = '<i class="bi bi-trash"></i>';

      li.appendChild(label);
      li.appendChild(removeBtn);
      this.listTarget.appendChild(li);
    });
  }
}
